import { render, staticRenderFns } from "./MantenedorLocalidadBase.vue?vue&type=template&id=718ecf2c&"
import script from "./MantenedorLocalidadBase.vue?vue&type=script&lang=ts&"
export * from "./MantenedorLocalidadBase.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorLocalidadBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('718ecf2c', component.options)
    } else {
      api.reload('718ecf2c', component.options)
    }
    module.hot.accept("./MantenedorLocalidadBase.vue?vue&type=template&id=718ecf2c&", function () {
      api.rerender('718ecf2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorLocalidad/MantenedorLocalidadBase.vue"
export default component.exports